// Datum dogadjaja za blokove. Ako dogadjaj ima opis vremena ("petak od 07h"), prikazuje se on, inace jedan dan
// ili raspon od dva dana.
export function useEventDates() {
  const dayjs = useDayjs()

  const part = (date: string) => ({ day: dayjs(date).format('D'), month: dayjs(date).format('MMM').replace('.', '') })

  // { text } kad postoji opis vremena, inace { parts: [{ day, month }] } (1 ili 2 dana)
  const eventDateParts = (event: Record<string, any>): { text?: string; parts: { day: string; month: string }[] } => {
    const text = event?.description_time
    if (text != null && String(text).trim() !== '') return { text: String(text).trim(), parts: [] }

    if (!event?.start_date) return { parts: [] }
    if (!event.end_date || dayjs(event.start_date).isSame(dayjs(event.end_date), 'day')) return { parts: [part(event.start_date)] }

    return { parts: [part(event.start_date), part(event.end_date)] }
  }

  return { eventDateParts }
}
